module.exports = __webpack_public_path__ + "img/speciaal-bier.def37bd6.webp";